import api from "./api";
import auth from "./auth";

export default {
    getList(page, filter) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/list/" + page,
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getProfile(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "customer-service/cms/customer/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    export(filter) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/export",
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    import(fields) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/import",
                fields,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateProfile(uuid, customer) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/update/" + uuid,
                customer,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomerInfos(uuids) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/infos",
                uuids,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomerFields() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/customer/fields", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    getMembershipID(param, filter = null) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/customer/list/" + param.page,
                filter,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getMembershipID(param, filter = null) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/customer/list/" + param.page,
                filter,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getApprovedCompanyCodeList(param) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/customer/company-code/approved/list",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getImportsStatus(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "customer-service/cms/customer/import/status/" +
                uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSummaryCount(params) {
        return new Promise((resolve, reject) => {
            api.post(
                `customer-service/cms/customer/registration-count`,
                params,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    listSpecialDiscountIds(customerUuid) {
        return new Promise((resolve, reject) => {
            api.get(
                `customer-service/cms/special_discount/list/${customerUuid}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateSpecialDiscountId(param) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/special_discount/update",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    voidSpecialDiscountId(param) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/special_discount/void",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
};
